// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    // serverApiUrl: 'https://staging-api.lalooga.com/api',

    // serverApiUrl: 'https://api.lalooga.com/api',
    // url: 'https://api.lalooga.com/api',

    // serverApiUrl: 'http://localhost:9090/api',
    // url: 'http://localhost:9090/api',
    serverApiUrl: 'http://lalooga-staging-env.eba-yuyvmpib.af-south-1.elasticbeanstalk.com/api',
    url: 'http://lalooga-staging-env.eba-yuyvmpib.af-south-1.elasticbeanstalk.com/api',
    lambdaApiUrl: 'https://lor15s68p3.execute-api.af-south-1.amazonaws.com/Prod',
    answerFallbackLambdaApiUrl: 'https://lor15s68p3.execute-api.af-south-1.amazonaws.com/Prod',
    cookieDomain: 'localhost'

  // cognito: {
    //     userPoolId: 'us-east-2_LRZTAlmdv',
    //     userPoolWebClientId: '2sekjri55o8emtd7kth4dm88pj'
    // }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
